/*
 * @Author: 朱亚
 * @Date: 2025-06-16 10:19:09
 * @说明：发送微信消息
 */
// 定义插件
const install = Vue => {
  if (install.installed) return
  install.installed = true
  const shareMessage = (msgContent) => {
    ww.checkJsApi({
      jsApiList: ['sendChatMessage'],
      success: (res) => {
        if (res.checkResult.sendChatMessage) {
          ww.invoke('sendChatMessage', msgContent, (res) => {
            if (res.errMsg === 'sendChatMessage:ok') {
              console.log('发送成功')
            } else {
              Vue.$vux.toast.show({ text: res.errMsg, type: 'text' })
            }
          })
        } else {
          Vue.$vux.alert.show({
            title: '错误提示',
            content: '缺少消息发送权限，' + JSON.stringify(res.checkResult),
            buttonText: '知道了'
          })
        }
      },
      fail: (err) => {
        if (err.errMsg === 'sendChatMessage:fail_nopermission') {
          Vue.$vux.alert.show({
            title: '错误提示',
            content: '您还没有操作权限，请在企业管理后台->客户与上下游->客户联系->权限配置中配置权限，设置成功后请等10分钟后再试。',
            buttonText: '知道了'
          })
        } else {
          Vue.$vux.alert.show({
            title: '错误提示',
            content: 'checkJsApi:' + err.errMsg,
            buttonText: '知道了'
          })
        }
      }
    })
    return true
  }
  const copyMessage = (msgContent) => {
    const textarea = document.createElement('textarea')
    textarea.value = msgContent
    document.body.appendChild(textarea)
    textarea.select()
    document.execCommand('copy')
    document.body.removeChild(textarea)
    Vue.$vux.toast.show({ text: '复制成功，赶快去粘贴分享', type: 'text' })
  }
  Object.defineProperties(Vue.prototype, {
    $shareMessage: {
      get() {
        return shareMessage.bind(this)
      }
    },
    $copyMessage: {
      get() {
        return copyMessage.bind(this)
      }
    }
  })
}
export default { install }



// WEBPACK FOOTER //
// ./src/plugins/shareUtil.js